import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-driver-status" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__filter" }
const _hoisted_4 = { class: "header__stats" }
const _hoisted_5 = { class: "eld_status" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = {
  key: 0,
  class: "action"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "new-modal"
}
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "description__footer" }

import {
  X,
  SearchMd,
  Plus,
  ArrowNarrowRight,
  RefreshCcw01,
} from "utruckin-icons";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { DateTime } from "luxon";
import { useCompanyStore } from "@/features/company/company.store";
import { ICompany } from "@/features/company/company.types";
import CommonButton from "@/components/common/CommonButton.vue";
import { useAppStore } from "@/store/app.store";
import CustomTab from "@/components/custom/CustomTab.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useNotification } from "@/utils/notification";
import { useDriverStatusStore } from "@/features/driver-status/driver-status.store";
import {
  IDriverStatus,
  INewDriverStatus,
  IWatchStatus,
} from "@/features/driver-status/driver-status.types";
import CustomStatusBadge from "@/components/custom/CustomStatusBadge.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CustomTableDropdown from "@/components/custom/CustomTableDropdown.vue";
import { useDriverStore } from "@/features/drivers/drivers.store";
import { IDriver } from "@/features/drivers/drivers.types";
import { ITeam } from "@/features/teams/team.types";
import { useTeamStore } from "@/features/teams/team.store";
import { useUserStore } from "@/features/users/user.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'DriverStatusView',
  setup(__props) {

const companyStore = useCompanyStore();
const appStore = useAppStore();

const driverStatusStore = useDriverStatusStore();
const driverStore = useDriverStore();
const teamStore = useTeamStore();
const usersStore = useUserStore();

const { pushNotification } = useNotification();

const loading = ref(false);
const search = ref<string>("");
const selectedItems = ref([]);
const companyTable = ref();
const activeTab = ref<"" | IWatchStatus>("");
const watches = ref<IDriverStatus[]>([]);
const tabs = [
  { label: "All", value: "" },
  { label: "Pending", value: "pending" },
  { label: "Done", value: "done" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Expired", value: "expired" },
  { label: "Failed", value: "failed" },
];

const team = ref<string>("");
const teams = ref<ITeam[]>([]);
const teamLoading = ref(false);

const companies = ref<ICompany[]>([]);
const companyLoading = ref(false);

const companyId = ref<string>("");

const drivers = ref<IDriver[]>([]);
const driverLoading = ref(false);

const isOpenModal = ref<boolean>(false);
const modalItem = ref<INewDriverStatus>({
  driver_id: "",
  target_status: "off",
  note: "",
  expires_in_hours: "",
});

let searchTimer: ReturnType<typeof setTimeout> | null = null;
let searchCompanyTimer: ReturnType<typeof setTimeout> | null = null;
let searchDriverTimer: ReturnType<typeof setTimeout> | null = null;

const targetStatuses = [
  { value: "off", name: "OFF" },
  { value: "sleep", name: "SB" },
  { value: "driving", name: "DR" },
  { value: "on", name: "ON" },
  { value: "yard", name: "YM" },
  { value: "personal", name: "PC" },
  { value: "any", name: "ANY" },
];

const companyItems = computed(() =>
  (companies.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.provider_name,
  }))
);

const driverItems = computed(() =>
  (drivers.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.truck_number,
  }))
);

const openModal = () => {
  modalItem.value = {
    driver_id: "",
    target_status: "off",
    note: "",
    expires_in_hours: "",
  };
  isOpenModal.value = true;
};

const closeModal = () => {
  modalItem.value = {
    driver_id: "",
    target_status: "off",
    note: "",
    expires_in_hours: "",
  };
  isOpenModal.value = false;
  companyId.value = "";
};

const saveModal = async () => {
  if (
    !modalItem.value ||
    !modalItem.value.driver_id ||
    !modalItem.value.expires_in_hours ||
    !modalItem.value.target_status
  )
    return;

  await driverStatusStore.createNewDriverStatus(
    loading,
    modalItem.value,
    (data: any) => {
      if (data) {
        pushNotification("Successfully saved", "success");
        closeModal();
        window.location.reload();
      }
    }
  );
};

function datepickerToUtcDateOnly(d: any) {
  return d
    ? DateTime.fromISO(d, {
        zone: "utc",
      })
        .setZone("America/New_York")
        .toFormat("MMM d, HH:mm")
    : "-";
}

const getList = async () => {
  await driverStatusStore.getDriverStatusList(loading, (res: any) => {
    if (res) {
      watches.value = res.items;
    }
  });
};

const searchCompany = (val: string) => {
  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);
  searchCompanyTimer = setTimeout(async () => {
    companyStore.commonSimpleFilter.search = val;
    companies.value = (
      await companyStore.getSimpleCompanies(companyLoading)
    ).items;
  }, 400);
};

const searchDriver = (val: string) => {
  if (searchDriverTimer) clearTimeout(searchDriverTimer);
  searchDriverTimer = setTimeout(async () => {
    driverStore.commonSimpleFilter.search = val;
    const [fetchedDrivers] = await Promise.all([
      driverStore.getSimpleDrivers(driverLoading),
    ]);

    drivers.value = fetchedDrivers.items;
  }, 400);
};

const checkWatch = async (item: IDriverStatus) => {
  if (!item.id) return;

  await driverStatusStore.checkWatch(loading, item.id, async (data: any) => {
    if (data) {
      pushNotification("Successfully checked", "success");
      await getList();
    }
  });
};

const cancelWatch = async (item: IDriverStatus) => {
  if (!item.id) return;
  await driverStatusStore.cancelWatch(loading, item.id, async (data: any) => {
    if (data) {
      pushNotification("Successfully canceled", "success");
      await getList();
    }
  });
};

onMounted(async () => {
  if (driverStatusStore.commonFilter.team_id) {
    team.value = driverStatusStore.commonFilter.team_id;
  } else {
    if (usersStore.userProfile && usersStore.userProfile.team_id) {
      team.value = usersStore.userProfile.team_id;
      driverStatusStore.commonFilter.team_id = team.value;
    }
  }

  await getList();

  const [fetchedCompanies, fetchedTeams] = await Promise.all([
    companyStore.getSimpleCompanies(companyLoading),
    teamStore.getTeams(teamLoading),
  ]);

  teams.value = fetchedTeams;
  companies.value = fetchedCompanies.items;
});

onUnmounted(() => {
  driverStatusStore.clearFilter();
});

watch(search, (val) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(async () => {
    driverStatusStore.commonFilter.search = val;
    await getList();
  }, 400);
});

watch(
  () => activeTab.value,
  async (newVal) => {
    driverStatusStore.commonFilter.status = newVal;
    await getList();
  },
  {
    immediate: false,
  }
);

watch(
  () => companyId.value,
  async (val) => {
    drivers.value = [];
    modalItem.value.driver_id = "";

    if (val) {
      driverStore.commonSimpleFilter.company_id = val;
      const [fetchedDrivers] = await Promise.all([
        driverStore.getSimpleDrivers(driverLoading),
      ]);

      drivers.value = fetchedDrivers.items;
    }
  }
);

watch(
  () => team.value,
  async (val: string) => {
    if (loading.value) return;
    driverStatusStore.commonFilter.team_id = val;
    await getList();
  },
  { immediate: false }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CustomTab, {
          tabs: tabs,
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CommonSearch, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          icon: _unref(SearchMd),
          placeholder: "Search",
          clearable: "",
          disabled: selectedItems.value.length > 0
        }, null, 8, ["modelValue", "icon", "disabled"]),
        _createVNode(CommonDropdown, {
          modelValue: team.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((team).value = $event)),
          items: teams.value.map((t) => ({ value: t.id, name: t.name })),
          label: "Team",
          position: "bottom",
          dropdownFullWidth: "",
          clearable: ""
        }, null, 8, ["modelValue", "items"]),
        _createVNode(CommonButton, {
          type: "primary",
          label: "Add watch",
          prepend: "",
          prependIcon: _unref(Plus),
          onClick: openModal
        }, null, 8, ["prependIcon"])
      ])
    ]),
    _createVNode(CommonTable, {
      ref_key: "companyTable",
      ref: companyTable,
      headers: _unref(driverStatusStore).driverStatusHeaders,
      loading: loading.value,
      items: watches.value
    }, {
      id: _withCtx(({ index }) => [
        _createElementVNode("span", null, _toDisplayString(index + 1), 1)
      ]),
      expires_time: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.expires_time)), 1)
      ]),
      eld_status: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CustomStatusBadge, {
            label: item.initial_status
          }, null, 8, ["label"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ArrowNarrowRight), { size: 14 })
          ]),
          _createVNode(CustomStatusBadge, {
            label: item.target_status
          }, null, 8, ["label"])
        ])
      ]),
      last_seen_status: _withCtx(({ item }) => [
        _createVNode(CustomStatusBadge, {
          label: item.last_seen_status
        }, null, 8, ["label"])
      ]),
      actions: _withCtx(({ item }) => [
        (item.status == 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "action__item",
                onClick: ($event: any) => (checkWatch(item))
              }, [
                _createVNode(_unref(RefreshCcw01), { size: 18 })
              ], 8, _hoisted_8)), [
                [_directive_tooltip, {
              content: 'Check',
              html: true,
            }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "action__item",
                onClick: ($event: any) => (cancelWatch(item))
              }, [
                _createVNode(_unref(X), { size: 18 })
              ], 8, _hoisted_9)), [
                [_directive_tooltip, {
              content: 'Cancel',
              html: true,
            }]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
      ]),
      _: 1
    }, 8, ["headers", "loading", "items"]),
    _createVNode(CommonModal, {
      modelValue: isOpenModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isOpenModal).value = $event)),
      title: "Add watch"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        (modalItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(CustomTableDropdown, {
                  modelValue: companyId.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((companyId).value = $event)),
                  items: companyItems.value,
                  label: "Company",
                  position: "bottom",
                  clearable: "",
                  fullWidth: "",
                  isAppendItem: "",
                  dropdownFullWidth: "",
                  onSearch: searchCompany
                }, null, 8, ["modelValue", "items"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(CustomTableDropdown, {
                  modelValue: modalItem.value.driver_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modalItem.value.driver_id) = $event)),
                  items: driverItems.value,
                  label: "Driver",
                  fullWidth: "",
                  clearable: "",
                  position: "bottom",
                  isAppendItem: "",
                  onSearch: searchDriver
                }, null, 8, ["modelValue", "items"])
              ]),
              _createVNode(CommonDropdown, {
                modelValue: modalItem.value.target_status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalItem.value.target_status) = $event)),
                items: targetStatuses,
                label: "Target status",
                position: "bottom",
                dropdownFullWidth: "",
                fullWidth: ""
              }, null, 8, ["modelValue"]),
              _createVNode(CommonInput, {
                modelValue: modalItem.value.expires_in_hours,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modalItem.value.expires_in_hours) = $event)),
                mask: "##",
                label: "Expire in hours"
              }, null, 8, ["modelValue"]),
              _createVNode(CommonInput, {
                modelValue: modalItem.value.note,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modalItem.value.note) = $event)),
                label: "Note",
                multiline: ""
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})